// jshint esversion: 6
// retrieve deferred oembed elements
let oembedVideos = document.getElementsByClassName( 'js-defer-oembed' );

// check for deferred element(s) existence
if ( oembedVideos.length ) {

    // set the iframe's [data-src] to the [src]
    function loadContent ( iframe ) {
        let src = iframe.getAttribute( 'data-src' );

        if ( src ) {
            iframe.setAttribute( 'src', src );
        }
    }

    // page has loaded, retrieve content
    window.addEventListener('load', function () {

        // load content for each deferred element
        for ( let i = 0; i < oembedVideos.length; i++ ) {
            loadContent( oembedVideos[i] );
        }

    }, false);

}
